"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeYyyyMmDd = exports.serializeYyyyMmDd = void 0;
const dto_1 = require("@flexidao/dto");
const serializeYyyyMmDd = (yyMmDdd) => yyMmDdd;
exports.serializeYyyyMmDd = serializeYyyyMmDd;
const deserializeYyyyMmDd = (s) => {
    if ((0, dto_1.validateYyyyMmDd)(s)) {
        return s;
    }
    throw new Error(`Invalid yy-mm-dd: '${s}' should be on the format 'yyyy-MM-dd'`);
};
exports.deserializeYyyyMmDd = deserializeYyyyMmDd;
//# sourceMappingURL=yyyy-mm-dd.js.map